export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly response: Response,
    readonly responseBody: string
  ) {
    super();
    this.status = status;
    this.response = response;
    this.responseBody = responseBody;
  }
}

export const isApiError = (a: unknown): a is ApiError => a instanceof ApiError;
